import React from "react"
import useMedia from "@/common/hooks/use_media"

interface MediaQueryProps {
  query: string
  children?: React.ReactNode | ((matches: boolean) => React.ReactNode)
}

const MediaQuery: React.FC<MediaQueryProps> = ({ query, children }) => {
  const matches = useMedia(query)

  if (typeof children === "function") {
    return children(matches) as React.ReactElement
  }

  if (!matches) {
    return null
  }

  return <>{children}</>
}

export default MediaQuery
